import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

import Home24Storage from './Home24Storage.vue'
declareVconsoleComponent('home24Storage', Home24Storage, 'home24:storage');